var path = 'app/controllers/home/template.html';
var html = "<main-layout heading=\"$ctrl.title\" is-slider-visible=\"true\">\n\n  <div class=\"top-products\">\n    <top-products></top-products>\n  </div>\n\n</main-layout>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;